import HelpNoticeDetailsContainer from './HelpNoticeDetailsContainer';
export default HelpNoticeDetailsContainer;
